export const ADD_CONTACT = 'ADD_CONTACT';
export const SEARCH_CONTACT = 'SEARCH_CONTACT';
export const ADD_STUDENT_CONTACT = 'ADD_STUDENT_CONTACT';
export const SEARCH_STUDENT_CONTACT = 'SEARCH_STUDENT_CONTACT';
export const UPDATE_SEARCH_CONTACT = "UPDATE_SEARCH_CONTACT";